export default "__VITE_ASSET__BfPefYb7__"